import gql from "graphql-tag"
import { graphql } from "react-apollo"
import momentPropTypes from "react-moment-proptypes"
import PropTypes from "prop-types"

import { GRAPHQL_DATE_FORMAT } from "../../helpers/sharedConstants"
import AssetHistoryTable from "."

const query = gql`
  query AssetVisitsHistory($assetId: ID!, $startAt: String!, $endAt: String!) {
    asset(id: $assetId) {
      deviceType {
        name
      }
      assetId
      hwid
      assetVisits(startAt: $startAt, endAt: $endAt) {
        edges {
          node {
            id
            entryAt
            exitAt
            location {
              name
            }
            unit {
              name
            }
          }
        }
      }
    }
  }
`

const AssetHistoryTableWithData = graphql(query, {
  options: props => ({
    variables: {
      assetId: props.id,
      startAt: props.startAt.format(GRAPHQL_DATE_FORMAT),
      endAt: props.endAt.format(GRAPHQL_DATE_FORMAT),
    },
  }),
  props: ({ data: { error, loading, asset }, ownProps }) => {
    if (error) {
      throw error
    }
    if (loading) {
      return { loading }
    }
    return {
      data: {
        deviceType: asset.deviceType.name,
        assetId: asset.assetId,
        badgeHwid: asset.hwid,
        visits: asset.assetVisits.edges.map(item => ({
          id: item.node.id,
          entryAt: item.node.entryAt,
          exitAt: item.node.exitAt,
          location: {
            locationName: item.node.location.name,
            unitName: item.node.unit.name,
          },
        })),
      },
    }
  },
})(AssetHistoryTable)

AssetHistoryTableWithData.propTypes = {
  id: PropTypes.string.isRequired,
  startAt: momentPropTypes.momentObj.isRequired,
  endAt: momentPropTypes.momentObj.isRequired,
}

export default AssetHistoryTableWithData
